import {createContext,useContext,useLayoutEffect,useRef,useState} from 'react';
import {useLocation} from 'react-router-dom';

const NavigationContext=createContext(null);
const RegistrationContext=createContext(null);

export function AgentMobilePageHeaderProvider({children}){
 const [navigation,setNavigation]=useState(null);
 return <RegistrationContext.Provider value={setNavigation}><NavigationContext.Provider value={navigation}>{children}</NavigationContext.Provider></RegistrationContext.Provider>;
}

// Keep page-local navigation callbacks out of the Redux store.
export function useAgentMobilePageHeader(title,onBack,backLabel='목록으로 돌아가기'){
 const register=useContext(RegistrationContext);
 const {pathname}=useLocation();
 const backRef=useRef(onBack);
 const hasBack=typeof onBack==='function';
 useLayoutEffect(()=>{backRef.current=onBack;});
 useLayoutEffect(()=>{
  if(!register)return;
  const entry={pathname,title,backLabel,onBack:hasBack?()=>backRef.current?.():null};
  register(entry);
  return()=>register(current=>current===entry?null:current);
 },[register,pathname,title,hasBack,backLabel]);
}

export function useAgentMobilePageNavigation(){
 const navigation=useContext(NavigationContext);
 const {pathname}=useLocation();
 return navigation?.pathname===pathname?navigation:null;
}
